import { render, staticRenderFns } from "./Certified.vue?vue&type=template&id=46482b49&"
import script from "./Certified.vue?vue&type=script&lang=js&"
export * from "./Certified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports